<template>
  <div class="page whatsapp-templates">
    <div class="row">
      <div class="col-12">
        <h2>WhatsApp Templates</h2>
      </div>
    </div>

    <div class="whatsapp-templates__list">
      <div class="header">
        <div class="header__name">Name</div>
        <div class="header__category">Category</div>
        <div class="header__language">Language</div>
        <div class="header__status">Status</div>
        <div class="header__last-updated">Last Updated</div>
        <div class="header__actions"></div>
      </div>
      <div class="template" v-for="(template) of whatsAppTemplates" v-bind:key="template.reference" v-on:click.stop="editTemplate(template)">
        <div class="template__name">{{template.name}}</div>
        <div class="template__category">{{template.category}}</div>
        <div class="template__language">{{getLanguageNameFromCode(template.language)}}</div>
        <div class="template__status" v-html="templateStatusForDisplay(template)"></div>
        <div class="template__last-updated">{{friendlyDate(template.lastUpdated)}}</div>
        <div class="template__actions"><i class="fas fa-ellipsis-h"></i></div>
      </div>
      <div v-if="whatsAppTemplates.length === 0" class="whatsapp-templates__list__no-templates">
        You haven't created any WhatsAppTemplates yet
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 text-right">
        <button v-on:click.stop="addTemplate" class="btn btn-primary">Add a Template</button>
      </div>
    </div>

    <edit-template v-if="showEditTemplateDialog" v-bind:template="templateToEdit"></edit-template>
  </div>
</template>

<script>
    // import Spinner from '../components/Spinner.vue'

    import EditTemplate from '../components/whatsapp/EditTemplate'

    import {datesMixin} from "../mixins/DatesMixin"
    import {languagesMixin} from '../mixins/LanguagesMixin'
    import {whatsAppTemplatesMixin} from "../mixins/WhatsAppTemplatesMixin"

    export default {
        name: 'WhatsAppTemplates',
        components: { EditTemplate },
        mixins: [datesMixin, languagesMixin, whatsAppTemplatesMixin],
        data: function () {
            return {
                // templates: [
                //     {
                //         reference: "ABC",
                //         name: "arrival_day_info",
                //         category: "utility",
                //         language: "en",
                //         contentType: "text",
                //         content: "Hi {{1}}. We look forward to your arrival at Seaside Villas today at {{2}}. Please call us on +27 21 762 1409 if your arrival time changes or if you need assistance finding us. Kind regards Seaside Villas.",
                //         sampleVariables: ["John", "14:00"],
                //         status: "under-review",
                //         lastUpdated: "2024-05-10T10:25:00.000Z"
                //     },
                //     {
                //         reference: "DEF",
                //         name: "online_registration",
                //         category: "utility",
                //         language: "en",
                //         contentType: "text",
                //         content: "Hi {{1}}. Thank your for booking at Seaside Villas, for arrival on {{2}}. Please take a moment to open our registration form: {{3}} and fill it in online. Kind regards Seaside Villas.",
                //         sampleVariables: ["John:", "14 July", "https://www.google.com"],
                //         status: "approved",
                //         lastUpdated: "2024-05-10T10:25:00.000Z"
                //     },
                // ],
                templateToEdit: null,
                showEditTemplateDialog: false
            }
        },
        computed: {
        },
        methods: {
            addTemplate: function() {
                console.log("Adding a Template");
                this.templateToEdit = {name: "", category: "utility", language: "en", contentType: "text", content: "", status: "under-review", lastUpdated: null, sampleVariables: []};
                this.showEditTemplateDialog = true;
            },
            editTemplate: function (template) {
                console.log("Editing: " + template.reference);
                this.templateToEdit = template;
                this.showEditTemplateDialog = true;
            },
            stopEditingTemplate() {
                this.templateToEdit = null;
                this.showEditTemplateDialog = false;
            }
        },
        mounted() {
            this.fetchWhatsAppTemplates();
            this.$root.$on("finished-editing-template", this.stopEditingTemplate);
        }, beforeDestroy() {
            this.$root.$off("finished-editing-template", this.stopEditingTemplate);
        }
    }
</script>

<style lang="scss" scoped>
  @import "../styles/pages/whatsapp-templates";
</style>
